import {IVStoreState} from '../useIVStore';

export const getBiomatchResultData = (state: IVStoreState) => state.biomatchResultData;
